import { format } from "date-fns";

import { DesignToken } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";
import { DateFormat } from "constants/date";
import {
  cannedResponseWasUpdated,
  getCannedResponseAuthorName,
  getCannedResponseAuthorType,
} from "helpers/canned-responses-settings";
import { withVar } from "themes/helpers";

import { UpdateInformationText } from "./styles";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const CannedInformation = ({ cannedResponse, agents }: any) => {
  const cannedResponseUpdated = cannedResponseWasUpdated(cannedResponse);
  const cannedResponseCreatedAutomatically = getCannedResponseAuthorType(cannedResponse) === "system";
  return (
    <UpdateInformationText>
      {cannedResponseCreatedAutomatically && (
        <Text fontSize="14px" lineHeight="20px" color={withVar(DesignToken.ContentBasicDisabled)}>
          {cannedResponseUpdated ? "Updated" : "Added"} automatically on{" "}
          {format(cannedResponse.updatedAt, DateFormat.DateWithoutDayOfTheWeek)}
        </Text>
      )}
      {!cannedResponseCreatedAutomatically && (
        <>
          <Text fontSize="14px" lineHeight="20px">
            {getCannedResponseAuthorName(cannedResponse, agents)}
          </Text>
          <Text fontSize="14px" lineHeight="20px" color={withVar(DesignToken.ContentBasicDisabled)}>
            {cannedResponseUpdated ? "updated" : "added"} this response on{" "}
            {format(cannedResponse.updatedAt, DateFormat.DateWithoutDayOfTheWeek)}
          </Text>
        </>
      )}
    </UpdateInformationText>
  );
};

export default CannedInformation;
